<script>
  export let h1, hStyle ='mt-14'
</script>
<div class="max-w-xl 2xl:max-w-2xl w-full mx-auto">
  {#if h1}
  <h1 class="text-left font-display {hStyle}">
    {#if h1}
      {#if Array.isArray(h1)}
        <span class="text-body text-poppy">{h1[0]}</span>
        <span class="block text-4xl sm:text-5xl lg:text-6xl text-gray-100 mt-4">{h1[1]}</span>
      {:else}
      {h1}
      {/if}
    {/if}
  </h1>
  {/if}
</div>